module.exports = __webpack_public_path__ + "media/images/top/feature/feature-4-246714c04f42e51f08d489d4d96c9ebc.png";